import { render, staticRenderFns } from "./Embedded.vue?vue&type=template&id=06de80e2&scoped=true&"
import script from "./Embedded.vue?vue&type=script&lang=js&"
export * from "./Embedded.vue?vue&type=script&lang=js&"
import style0 from "./Embedded.vue?vue&type=style&index=0&id=06de80e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de80e2",
  null
  
)

export default component.exports